import AWS from 'aws-sdk'

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY || '',
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY || '',
  region: process.env.REACT_APP_AWS_REGION || '',
})

export default async function useAudioLoader(
  audioPath: string
): Promise<string> {
  try {
    const params = {
      Bucket: process.env.REACT_APP_AWS_S3_BUCKET_NAME || '',
      Key: audioPath,
    }
    const { Body, ContentType } = await s3.getObject(params).promise()

    const blob = new Blob([Body as BlobPart], { type: ContentType })
    localStorage.setItem(audioPath, URL.createObjectURL(blob))
    // const file = new File([blob], audioPath, { type: ContentType })
  } catch (error) {
    console.log(error)
  }

  return 'success'
}
